import {scrollToEl} from "../utility/utils";

export default function smoothScrollAnchorLinks(){
    // Smooth Scrolling Anchor links / Prevent Default on href="#" links
    document.addEventListener(
        "click",
        function (e) {
            // loop parent nodes from the target to the delegation node
            for (let target = e.target; target && target !== this; target = target.parentNode) {
                if (target.matches("a")) {
                    const href = target.getAttribute("href");
                    if (/^#/.test(href)) {
                        const hash = href.substring(href.indexOf("#"));
                        const hashTarget = document.getElementById(hash.substring(1));
                        if (hash !== "#" && hashTarget && !hashTarget.classList.contains('modal')) {
                            e.preventDefault();
                            target.blur();
                            scrollToEl(hashTarget);
                        } else if (hash === "#") {
                            e.preventDefault();
                            target.blur();
                        }
                    }
                    break;
                }
            }
        },
        false
    );
}